/**
 * @Description 点位信息
 */
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import { Col, Row } from 'antd';
import { FC } from 'react';
const Info:FC<any> = ({
  conflictInfo
}) => {
  return <div className='mb-24'>
    <Row gutter={16}>
      <Col span={12}>
        <V2DetailItem label='点位名' value={conflictInfo?.name}/>
      </Col>
      <Col span={12}>
        <V2DetailItem label='详细地址' value={conflictInfo?.address}/>
      </Col>
    </Row>

    {conflictInfo?.reason ? <V2DetailItem label='申请理由' value={conflictInfo?.reason}/> : <></>}

  </div>;
};
export default Info;
